interface PaginationProps {
  currentPage: number;
  totalItems: number;
  totalPages: number;
  onPageChange: (page: number) => void;

  itemsPerPage: number;
  onItemsPerPageChange: (itemsPerPage: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalItems,
  totalPages,
  onPageChange,
  itemsPerPage,
  onItemsPerPageChange,
}) => {
  return (
    <div className="flex gap-2 flex-col items-center">
      <div className="flex gap-2 flex-row ">
        <button
          disabled={currentPage <= 1}
          onClick={() => onPageChange(1)}
          className="w-[50px] h-[50px] bg-[#FFC93D] text-black disabled:bg-[#202020]"
        >
          First
        </button>
        <button
          disabled={currentPage <= 1}
          onClick={() => onPageChange(currentPage - 1)}
          className="w-[50px] h-[50px] bg-[#FFC93D] text-black disabled:bg-[#202020]"
        >
          Prev
        </button>
        <button
          disabled={currentPage + 1 > totalPages}
          onClick={() => onPageChange(currentPage + 1)}
          className="w-[50px] h-[50px] bg-[#FFC93D] text-black disabled:bg-[#202020]"
        >
          Next
        </button>

        <button
          disabled={currentPage + 1 > totalPages}
          onClick={() => onPageChange(totalPages)}
          className="w-[50px] h-[50px] bg-[#FFC93D] text-black disabled:bg-[#202020]"
        >
          Last
        </button>

      </div>

      <div className="flex flex-col items-center gap-4 text-gray-700 dark:text-gray-200 md:flex-row">
        <div>Total items: {totalItems ?? 0}</div>
        <div>Page: {Math.max(currentPage, 1)}</div>
        <div>Pages: {Math.max(totalPages ?? 1, 1)}</div>
      </div>

      {/* <select
        value={itemsPerPage}
        onChange={e => onItemsPerPageChange(Number(e.target.value))}
        className="m-0 h-10 p-2"
      >
        {[10, 20, 30, 40, 50].map(pageSize => (
          <option key={pageSize} value={pageSize}>
            {pageSize}
          </option>
        ))}
      </select> */}
    </div>
  );
};

export default Pagination;
